
define('text!templates/content/market.html',[],function () { return '<div class="panel panel-transparent">\n    <div class="panel-body">\n\n        <div class="row">\n\n            <div class="col-xs-12  basket-container">\n\n            </div>\n\n            <div class="col-xs-12  store-container">\n\n            </div>\n\n        </div>\n\n    </div>\n</div>';});

